/* eslint-disable react/prop-types */
import React from 'react';

export const TABS = [
  { key: 'heart-rate', label: 'Alerts' },
  { key: 'pauses', label: 'Pauses' },
  { key: 'standing', label: 'Standing checks' },
  { key: 'sleep', label: 'Sleep' },
  { key: 'bio-vitals', label: 'Bio vitals' },
  { key: 'monitor', label: 'Monitor sessions' },
  { key: 'medicine', label: 'Medicine' },
  // Activity log = app access (user_app_access_log) — the New Open / Resume feed the Users
  // list links into. The key stays 'app-access' so existing ?tab= links keep working.
  { key: 'app-access', label: 'Activity log' },
  // Free access grant history (079) — every grant this member has been given, revoked and
  // expired included. Read-only; granting starts from the identity card.
  { key: 'free-access', label: 'Free access' },
  // Every other users column (the identity card keeps only the headline facts). Reads the
  // already-fetched profile, so like Free access it ignores the date range.
  { key: 'profile', label: 'Profile details' },
  // Subscription tab hidden for now (kept in the codebase for later): { key: 'subscription', label: 'Subscription' },
];

// Subscription and Free access are lifecycle-based, not window-based — the date range does not
// apply to either. Reading half an audit trail is worse than reading none of it.
// (Subscription is currently hidden; listed here so the control stays correct if re-enabled.)
export const DATE_DRIVEN = new Set(['heart-rate', 'pauses', 'standing', 'sleep', 'bio-vitals', 'monitor', 'medicine', 'app-access']);

const UserDetailTabs = ({ active, onSelect }) => (
  <div className="ud-tabs" role="tablist" aria-label="User detail sections" data-testid="ud-tabs">
    {TABS.map((t) => (
      <button
        key={t.key}
        type="button"
        role="tab"
        aria-selected={active === t.key}
        className={`ud-tab${active === t.key ? ' ud-tab--on' : ''}`}
        data-testid={`ud-tab-${t.key}`}
        onClick={() => onSelect(t.key)}
      >
        {t.label}
      </button>
    ))}
  </div>
);

export default UserDetailTabs;
